import React from "react";
import { CreateProfile } from "../../Create";
import { useAuth } from "../../../../context/AuthContext";

export default function UpdateProfile() {
  const { user } = useAuth();
  const roleId = Number(user?.roleid);
  const isDirector = roleId === 2;
  return <CreateProfile showAddButton={false} viewReadOnly={isDirector} />;
}
